import { useEffect } from 'react';

let lockCount = 0;
let savedScrollY = 0;

function applyLock() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.width = '100%';
}

function releaseLock() {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  document.body.style.paddingRight = '';
  window.scrollTo(0, savedScrollY);
}

/**
 * Prevents the page behind a modal from scrolling while the modal is open.
 * Supports nested modals (e.g. tour details → booking) via a ref counter.
 */
export function useLockBodyScroll(lock) {
  useEffect(() => {
    if (!lock) return;

    if (lockCount === 0) {
      savedScrollY = window.scrollY;
      applyLock();
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount === 0) {
        releaseLock();
      }
    };
  }, [lock]);
}
